import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { getLabInfo } from 'kb-shared/utilities/kindbody_contacts';
import { isDisneyPatient } from 'kb-shared/utilities/lab.helper';
import { EnvironmentType } from '../types';

type ResponseData = {
  patient: {
    lab: {
      id: string;
    };
  };
  journeyType: string;
};

const CONTACT_INFO = gql`
  query contactInfo {
    patient {
      id
      lab {
        id
      }
    }
    journeyType
  }
`;

export const useContactInfo = (env: EnvironmentType, isLoggedIn: boolean) => {
  const { data, error } = useQuery<ResponseData>(CONTACT_INFO, {
    skip: !isLoggedIn
  });
  if (!data || error) {
    return getLabInfo('NONE', env);
  }
  const { journeyType, patient } = data;

  // show generic contact info if patient does not have a cycle
  // always show disney contact info if disney patient
  const labId = isDisneyPatient(env, patient.lab.id)
    ? patient.lab.id
    : journeyType && patient.lab.id;

  const labInfo = getLabInfo(labId || 'NONE', env);
  return labInfo;
};
